import Axios from "axios";
import * as React from "react";
import { withRouter } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import { Space, Spin } from "antd";

const PrivateEquityPage = (props: any) => {
  const [isLoading, setIsLoading] = React.useState(true);
  const [htmlContent, setHtmlContent] = React.useState("");


  React.useEffect(() => {
    if (!isLoading) {
      setIsLoading(true);
    }

    Axios.get(
      props.match.url.replace("shares", "").replace("/private-equity", "") +
        "/portfolio.json"
    ).then((resp) => {
      setHtmlContent(resp.data.partial);
      setIsLoading(false);
      setTimeout(() => {
        (
          document.getElementsByClassName("investments_filters__btn")[0] as any
        ).click();
      }, 300);
    });
  }, [props.match.url]);

  if (isLoading)
    return (
      <Space
        align="center"
        style={{ justifyContent: "center", width: "100%", minHeight: 300 }}
      >
        <Spin size="large" />
      </Space>
    );

  return <>{ReactHtmlParser(htmlContent)}</>;
};

export default withRouter(PrivateEquityPage);
